import { render, staticRenderFns } from "./revisionChat.vue?vue&type=template&id=2f4910f2&"
import script from "./revisionChat.vue?vue&type=script&lang=js&"
export * from "./revisionChat.vue?vue&type=script&lang=js&"
import style0 from "./revisionChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports